/**
 * LLSA Hero Zip Code Search Functionality
 * Handles zip code input validation, session storage management, and search functionality
 * for the hero section zip code search.
 */

(function () {
  'use strict';

  // Clear zip code session storage
  function clearZipCodeSessionStorage() {
    try {
      // Try to use the centralized clear function if available
      if (typeof window.clearZipCodeFromSession === 'function') {
        window.clearZipCodeFromSession();
      } else {
        // Fallback to direct sessionStorage clearing
        sessionStorage.removeItem('validZipCode');
        sessionStorage.removeItem('zipCodeTimestamp');
        sessionStorage.removeItem('appointmentTimestamp');
        sessionStorage.removeItem('selectedAppointment');
        sessionStorage.removeItem('selectedPackage');
        sessionStorage.removeItem('packageTimestamp');
        sessionStorage.removeItem('selectedGender');
        sessionStorage.removeItem('genderTimestamp');
        sessionStorage.removeItem('selectedDateOfBirth');
        sessionStorage.removeItem('dobTimestamp');
      }
    } catch (error) {
      console.warn('Could not clear zip code session storage:', error);
    }
  }


  // Save zip code to session storage
  function saveZipCode(zipCode) {
    try {
      // Try to use the centralized session storage function if available
      if (typeof window.saveZipCodeToSession === 'function') {
        return window.saveZipCodeToSession(zipCode);
      } else {
        // Fallback to direct sessionStorage
        sessionStorage.setItem('validZipCode', zipCode);
        sessionStorage.setItem('zipCodeTimestamp', Date.now().toString());
        return true;
      }
    } catch (error) {
      console.warn('Could not save zip code to session storage:', error);
      return false;
    }
  }

  // Show zip code error message
  function showZipCodeError(message, zipInput) {
    if (!zipInput) return;

    // Remove any existing error message for this input
    clearZipCodeError(zipInput);

    // Create error message element
    const errorElement = document.createElement('div');
    errorElement.className = 'zip-code-error';
    errorElement.textContent = message;

    // Insert error message after the input
    zipInput.parentNode.insertBefore(errorElement, zipInput.nextSibling);
  }

  // Clear zip code error message
  function clearZipCodeError(zipInput) {
    if (!zipInput) return;

    // Find and remove error message after this specific input
    const nextSibling = zipInput.nextSibling;
    if (nextSibling && nextSibling.className === 'zip-code-error') {
      nextSibling.remove();
    }
  }

  // Handle search button click
  function handleSearchClick(e, zipInput) {
    const zipCode = (zipInput.value || '').trim();

    // Clear any existing error messages
    clearZipCodeError(zipInput);

    if (!zipCode) {
      e.preventDefault();
      showZipCodeError('Please enter a 5-digit zip code', zipInput);
      zipInput.focus();
      return;
    }

    if (zipCode.length !== 5) {
      e.preventDefault();
      showZipCodeError('Please enter a 5-digit zip code', zipInput);
      zipInput.focus();
      return;
    }

    // Save zip code to session storage
    saveZipCode(zipCode);

    // If appointment scheduling system is available, trigger the search
    if (typeof window.appointmentScheduling?.onZipCodeSearch === 'function') {
      window.appointmentScheduling.onZipCodeSearch(zipCode);
    }

    // Allow navigation to proceed
  }

  // Handle Enter key on input
  function handleInputEnter(e, searchButton) {
    if (e.key === 'Enter') {
      e.preventDefault();
      searchButton.click();
    }
  }

  // Initialize hero zip code search functionality
  function initHeroZipSearch() {
    const zipInput = document.getElementById('llsa-zip-code-search');
    const searchButton = document.getElementById('hero-zip-search-button');

    // Also handle the CTA section zip input
    const ctaZipInput = document.getElementById('cta-zip-code-search');
    const ctaSearchButton = document.getElementById('cta-zip-search-button');

    // Initialize hero section if it exists
    if (zipInput && searchButton) {
      initZipSearchElement(zipInput, searchButton);
    }

    // Initialize CTA section if it exists
    if (ctaZipInput && ctaSearchButton) {
      initZipSearchElement(ctaZipInput, ctaSearchButton);
    }
  }

  // Initialize a specific zip search element
  function initZipSearchElement(zipInput, searchButton) {
    // Clear any existing zip code session storage when element loads
    clearZipCodeSessionStorage();

    // Apply IMask if available
    if (window.IMask) {
      IMask(zipInput, { mask: '00000' });
    }

    // Set correct input attributes
    zipInput.setAttribute('type', 'text');
    zipInput.setAttribute('inputmode', 'numeric');
    zipInput.setAttribute('maxlength', '5');
    zipInput.setAttribute('pattern', '\\d{5}');
    zipInput.autocomplete = 'postal-code';

    // Add event listeners
    searchButton.addEventListener('click', function(e) {
      handleSearchClick(e, zipInput);
    });

    zipInput.addEventListener('keydown', function(e) {
      handleInputEnter(e, searchButton);
    });

    // Clear error message when user starts typing
    zipInput.addEventListener('input', function() {
      clearZipCodeError(zipInput);
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeroZipSearch);
  } else {
    initHeroZipSearch();
  }
})();
